import React from 'react'
import { InputNumber } from 'antd'
import './style.css'

const CustomInputNumber = (props) => {
	const { className, type, ...otherProps } = props
	return (
		<InputNumber
			{ ...otherProps }
			className={`custom-input-number ${ className ?? "" }`}
		/>
	)
}

export default CustomInputNumber